var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.configurando)?_c('v-container',{attrs:{"fluid":""}},[_c('Configurando')],1):_c('v-sheet',{staticStyle:{"min-height":"100%"}},[_c('v-main',[_c('v-layout',[_c('v-container',[_c('v-fade-transition',{attrs:{"mode":"out-in","appear":""}},[_c('router-view',{attrs:{"emisor":_vm.emisor}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }